import Fecth from './fetch';
import qs from 'qs';
import { dateFormat } from '../utils/utils';
import { ApiPath } from './config';

const dataUtil = {
  removeEmptyValue: data => {
    let result = {};
    for (var k in data) {
      if (data[k] != null) result[k] = data[k];
    }
    return result;
  },
};

export default class userFetch {
  constructor() {
    this.fetch = new Fecth(ApiPath, 'user');
  }
  getInitData(param) {
    return this.fetch.getRequest('', param);
  }
  // 获取用户信息
  getUserInfo() {
    return this.fetch.getRequest('/user/info', 'attach=users');
  }
  // 获取用户积分
  getUserScore() {
    return this.fetch.getRequest('/score/overview');
  }
  // 获取用户战绩
  getProfit() {
    return this.fetch.getRequest('/profit/overview');
  }
  // 获取我的会员
  getNexus() {
    return this.fetch.getRequest('/nexus/overview');
  }

  // 得到自己的openid
  getOpenid() {
    return this.fetch.getRequest('/debug/user/openid');
  }

  // 获取站点接口版本信息
  getSiteVersion() {
    return this.fetch.getRequest('/site/version');
  }

  // 得到自己的密码
  getPasswd() {
    return this.fetch.getRequest('/debug/user/passwd');
  }

  // 上传用户的本地数据
  reportLocal(data) {
    data = dataUtil.removeEmptyValue(data);
    return this.fetch.postRequest('/debug/report/local', qs.stringify(data));
  }

  // 上传资源文件
  upLoadFile(form) {
    return this.fetch.postRequest('/help/file/upload', form);
  }
  // 更改用户信息
  editUserInfo(data) {
    data = dataUtil.removeEmptyValue(data);
    return this.fetch.putRequest('/user/info', qs.stringify(data));
    // return this.fetch.putRequest('/user/info', data);
  }
  // 查询自己的所有零售佣金列表
  getIncomeRetail() {
    return this.fetch.getRequest('/income/retail/record/list','attach=users');
  }
  // 查询自己的所有零售佣金
  getTotalIncomeRetail() {
    return this.fetch.getRequest('/income/retail/sum');
  }
  // 查询自己的团队佣金记录列表
  getIncomeTeam() {
    return this.fetch.getRequest('/income/team/record/list','attach=users');
  }
  // 查询自己的所有零售佣金
  getTotalIncomeTeam() {
    return this.fetch.getRequest('/income/team/sum');
  }
  // 查询提现记录
  getWithDrawList() {
    return this.fetch.getRequest(
      '/profit/take/record/list',
      'status=refuse,accept,paying,paySure,apply'
    );
  }
  // 查询自己的零售层级概述/nexus/retail/level/overview
  getNexusRetailLevel(maxDeep) {
    return this.fetch.getRequest(
      '/nexus/retail/level/overview',
      `maxDeep=${maxDeep}`
    );
  }
  // 查询自己的团队层级概述/nexus/retail/level/overview
  getNexusTeamLevel(maxDeep) {
    return this.fetch.getRequest(
      '/nexus/team/level/overview',
      `maxDeep=${maxDeep}`
    );
  }
  // 查询自己的粉丝列表 /nexus/fans/list
  getFansList() {
    return this.fetch.getRequest(
      '/nexus/fans/list',
      `attach=users,inviteCodes`
    );
  }
  // 查询实时佣金排名top /profit/top/realtime
  getProfitRealTime(rankBy) {
    // return this.fetch.getRequest('/profit/top/realtime', `timeUnit=${rankBy}&pattern=retail`);
    return this.fetch.getRequest(
      '/profit/top/realtime',
      `timeUnit=${rankBy}&pattern=retail&attach=users`
    );
  }
  // 列出提现收款二维码 /profit/take/accept/qrcode
  getProfitAcceptQrcode(rankBy) {
    return this.fetch.getRequest('/profit/take/accept/qrcode');
  }
  // putRequest
  // 上传微信收款码/profit/take/accept/qrcode
  addWxAcceptQrcode(url) {
    return this.fetch.postRequest(
      `/profit/take/accept/qrcode`,
      {
        qrcodePath: url,
      },
      `qrcodePath=${url}`
    );
  }
  // 上传微信收款码/profit/take/accept/qrcode
  addAlipayAcceptQrcode(url) {
    return this.fetch.postRequest(
      `/profit/take/accept/qrcode`,
      {
        qrcodePath: url,
      },
      `qrcodePath=${url}`
    );
  }
  // 上传微信收款码/profit/take/accept/qrcode
  changeWxAcceptQrcode(url) {
    return this.fetch.putRequest(
      `/profit/take/accept/qrcode`,
      {
        qrcodePath: url,
      },
      `qrcodePath=${url}`
    );
  }
  // 上传微信收款码/profit/take/accept/qrcode
  changeAlipayAcceptQrcode(url) {
    return this.fetch.putRequest(
      `/profit/take/accept/qrcode`,
      {
        qrcodePath: url,
      },
      `qrcodePath=${url}`
    );
  }
  // 余额申请提现/profit/take/apply
  profitTakeApply(money) {
    return this.fetch.postRequest(
      `/profit/take/apply`,
      {
        money: (money * 100).toFixed(0),
      },
      `money=${(money * 100).toFixed(0)}`
    );
  }
  // 获取渠道信息
  getChannelList() {
    return this.fetch.getRequest(
      '/invite/channel/list',
      'channelOverview=true'
    );
  }
  // 获取用户余额
  getUserProfit() {
    return this.fetch.getRequest('/profit/overview/surplus');
  }
  // 获取朋友圈推广海报 /invite/channel/weixin/poster/list
  getFriendEnvPoster() {
    return this.fetch.getRequest(
      '/invite/channel/weixin/poster/list',
      'channelType=wxFriendEnv'
    );
  }
  // 获取好友推广海报 /invite/channel/weixin/poster/list
  getFriendPoster() {
    return this.fetch.getRequest(
      '/invite/channel/weixin/poster/list',
      'channelType=wxFriend'
    );
  }
  // 获取自己的佣金排名
  getOwnRank(rankBy) {
    return this.fetch.getRequest(
      '/profit/ranking/realtime',
      `timeUnit=${rankBy}&pattern=retail`
    );
  }
  // 确认余额申请提现到帐/profit/take/apply/sure
  confirmWithDraw(recordId) {
    return this.fetch.postRequest(
      `/profit/take/apply/sure`,
      {
        recordId: recordId,
      },
      `recordId=${recordId}`
    );
  }
  // 意见反馈
  feedBack(item) {
    return this.fetch.postRequest(
      `/help/user/feedback`,
      null,
      `picUrl=${item.imgUrl}&contact=${item.number}&userScore=${
        item.userScore
      }&content=${item.text}&defaultScore=4&clientType=tdtUserH5`
    );
  }
  // 上传临时文件，返回key
  upLoadTemp(form) {
    return this.fetch.postRequest('/help/file/upload/temp', form);
  }
  // 二维码猜测去重
  guess(item) {
    return this.fetch.getRequest(
      '/help/qrcode/parse/guess',
      `tempKey=${item.tempKey}&guess=${item.guess}&newSize=400`
    );
  }
  // 获取fans信息
  getFans(item) {
    return this.fetch.getRequest(
      '/report/overview/converge/time/list',
      `timeUnit=${item}&reportType=userFans&reportSubType=0`
    );
  }
  // 获取fans数据统计
  getFansSummary() {
    return this.fetch.getRequest(
      '/report/overview/converge/current/list',
      `reportType=userFans&reportSubType=0`
    );
  }
  // 修改channel名字/invite/channel
  changeChangeName(data) {
    return this.fetch.putRequest('/invite/channel', qs.stringify(data));
  }
  // 增加渠道/invite/channel
  addChannel() {
    return this.fetch.postRequest('/invite/channel', null);
  }

  //TODO 于毅 把这个方法和关联的东西都去掉吧。 SiteEnv.showSiteBase();可以拿到信息
  /*    getLoginConfig() {
        return this.fetch.getRequest('/site/base', '');
    }*/
  login(data) {
    return this.fetch.postRequest(
      '/auth/login/phone/passwd',
      qs.stringify(data)
    );
  }
  // /help/phone/valicode
  getLoginCode(data) {
    return this.fetch.getRequest('/help/phone/valicode', qs.stringify(data));
  }
  // /auth/login/phone/code
  loginWithCode(data) {
    return this.fetch.postRequest('/auth/login/phone/code', qs.stringify(data));
  }
  bindPhone(data) {
    return this.fetch.postRequest('/user/phone/bind', qs.stringify(data));
  }
  uploadBase64(data) {
    return this.fetch.postRequest(
      '/help/file/upload/base64',
      qs.stringify(data)
    );
  }
  ///auth/passwd
  setPassword(data) {
    return this.fetch.putRequest('/auth/passwd', qs.stringify(data));
  }
  getUserVar() {
    return this.fetch.getRequest('/site/env/var', null);
  }
  deleteOpenid() {
    return this.fetch.delRequest('/debug/user/weixin/openid');
  }
  // /invite/event/mark
  uploadInviteEvent(data) {
    return this.fetch.postRequest('/invite/event/mark', qs.stringify(data));
  }
  getMemberLevelList () {
    return this.fetch.getRequest('/setting/strategy/name');
  }
}



// WEBPACK FOOTER //
// ./src/fetch/user.js